module.exports = __webpack_public_path__ + "static/media/school-private.b9e51d59.png";